import React from 'react';
import { PRIMARY_ALT } from '../../../../theme';
export var Blob = function Blob(props) {
  var blobFill = props.color || PRIMARY_ALT;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 94 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2917 35.9414C100.565 61.4709 84.8844 73.1847 61.6106 82.1932C38.3369 91.2017 11.9524 77.8088 2.67934 52.2793C-6.59373 26.7498 9.36882 11.4504 32.6426 2.44192C55.9164 -6.5666 82.0186 10.4119 91.2917 35.9414Z",
    fill: blobFill
  }));
};